<script>
    import VulnerabilityBasicInfo from "./vulnerability-basic-info.svelte";
    import VulnerabilityDescription from "./vulnerability-description.svelte";
    import VulnerabilityReferences from "./vulnerability-references.svelte";
    import CVEData from "../_components/cve-data.svelte";
    import Form from '../../vulnerability/custom/_form.svelte';
    import { createEventDispatcher, onDestroy } from 'svelte'; 
    import { user } from '../../user/user.state.svelte.js';
    import { format, locale } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let vulnerability;
    export let navigation = false;

    let table_is_expanded            = false;
    let vulnerabilityReferencesShown = false;
    let lang = $locale;
    let titles_lang = $locale;

    // Estado nativo de Svelte para controlar el modal
    let showModal = false;

    let formData = {
        id: vulnerability.id,
        title: vulnerability.title,
        title_es: vulnerability.title_es,
        summary: vulnerability.summary,
        summary_es: vulnerability.summary_es,
        cwe_id: vulnerability.cwe_id,
        cvss3_vector: vulnerability.cvss3_vector,
        references: vulnerability.references
    }

    // Funciones reactivas sin depender de librerías externas
    const openModal = () => {
        showModal = true;
        document.body.classList.add("modal-open"); // Evita que el fondo haga scroll
    }

    const closeModal = () => {
        showModal = false;
        document.body.classList.remove("modal-open");
    }

    const handleAdd = async () => {
        closeModal();
    }

    const changeTitleLang = (current_lang) => {
        if(current_lang == 'es'){
            titles_lang = 'en';
        }
        if(current_lang == 'en'){
            titles_lang = 'es';
        }
        dispatch("changeLanguage");
    }

    // Limpieza de seguridad si el componente se destruye mientras el modal está abierto
    onDestroy(() => {
        document.body.classList.remove("modal-open");
    });
</script>

<style>
    .d-flex > * {
        flex: 1;
    }
    .flex-container-2item div:first-child {
        flex: 2;
    }
    .card + .card {
        margin-left: 14px;
    }
    .references-list {
        line-height: 1.5;
    }
    h4 small {
        font-size: 0.75rem;
        display: block;
    }
    .btn.btn-xs.btn-edit-vulnerability {
        margin-right: 15px;
    }
    .btn.btn-xs.btn-edit-vulnerability i {
        font-size: 16px;
    }

    .btn.btn-secondary.table-button.btn-language.btn-xs {
        margin: 0 !important;
        max-height: 24px;
    }
</style>

<div class="row">
    <div class="col-12 d-flex">
        <div class="card" style="flex: 2;">
            <div class="card-header">
                {#if $locale != "en"}
                    <div class="card-tools">
                        <button
                            class="btn btn-secondary table-button btn-language btn-xs"
                            title={lang == "es" ? "Ver idioma original" : "Ver idioma seleccionado"}
                            on:click={() => changeTitleLang(titles_lang)}
                        >
                            {#key titles_lang}
                                {#if titles_lang == "es"}
                                    <i class="flag-icon flag-icon-ar"></i>
                                {:else}
                                    <i class="flag-icon flag-icon-us"></i>
                                {/if}
                            {/key}
                        </button>
                    </div>
                {/if}
                <div class="card-title">
                    {$format("detail")}
                </div>
                {#if vulnerability.id.includes("X-")}
                    {#if user.data.is_internal}
                        <div class="card-tools">
                            <!-- El botón usa nuestra función Svelte -->
                            <button
                                class="btn btn-secondary table-button  btn-edit-vulnerability me-3  t-edit-vul"
                                on:click={openModal}
                            >
                                <i class="fas fa-edit"></i>
                            </button>
                        </div>
                    {/if}
                {/if}
            </div>
            {#key lang}
                <VulnerabilityDescription
                    {vulnerability}
                    language={titles_lang}
                    show_title={navigation}
                />
            {/key}
        </div>
        
        <div class="card">
            <div class="card-header">
                <div class="card-title">
                    {$format("data")}
                </div>
            </div>
            <div class="card-body d-flex flex-column">
                <VulnerabilityBasicInfo {vulnerability} {navigation} />
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 d-flex">
        {#if vulnerability.cvss4_vector || vulnerability.cvss3_vector || vulnerability.cvss2_vector}
            <div class="card" style="flex: 2;">
                <div class="card-header">
                    <div class="card-title">
                        {$format("page.vulnerability.cvss_data")}
                    </div>
                </div>
                <div class="card-body" style="flex: 2;">
                    <CVEData {vulnerability} />
                </div>
            </div>
        {/if}
        {#if vulnerability.references && vulnerability.references.length > 0}
            <div class="card">
                <div class="card-header">
                    <div class="card-title">
                        {$format("page.vulnerability.references")}
                    </div>
                </div>
                <div class="card-body">
                    <VulnerabilityReferences
                        references={vulnerability.references}
                    />
                </div>
            </div>
        {/if}
    </div>
</div>

<!-- FONDO OSCURO DEL MODAL (Renderizado condicionalmente por Svelte) -->
{#if showModal}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="modal-backdrop fade show" style="z-index: 1040;" on:click={closeModal}></div>
{/if}

<!-- VULS MODAL -->
<div
    class="modal fade {showModal ? 'show' : ''}"
    style="display: {showModal ? 'block' : 'none'}; z-index: 1055;"
    tabindex="-1"
    aria-hidden={!showModal}
    aria-modal={showModal}
    role="dialog"
>
    <div class="modal-dialog" style="max-width: 80% !important; width: 80%;">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("page.vulnerability.edit_priv_vul")}
                    <small>({$format("page.vulnerability.no_fields_required")})</small>
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    on:click={closeModal}
                    aria-label="Close"
                >
                </button>
            </div>
            <div class="modal-body">
                <Form
                    {formData}
                    references={formData.references ? formData.references : [""]}
                    on:save={handleAdd}
                    oncancel={closeModal}
                />
            </div>
        </div>
    </div>
</div>